$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
  searchBoxPlaceholder();
  createCustomToggle();
  makeAccessibleButton($('.close-mobile-menu'), 'close menu');
  adjustNav();
  removeFocusCart();

  if (window.location.pathname === '/') {
    modifySignup();
  }
});

$(window).load(function () {
  contentMarginTop();
});

function searchBoxPlaceholder() {
  const searchInput = $('header .inputFieldTextbox');
  const searchButton = $('header .searchSubmitButton');
  // set a placeholder to searchInput
  searchInput.attr('placeholder', 'Type here...');
  searchButton.attr('tabindex', '-1');
  searchButton.attr('aria-label', 'submit search');
}

function modifySignup() {
  const signupWidget = $('.tier-four .emailSignup');

  signupWidget.each(function () {
    const $this = $(this);
    const inputField = $this.find('.emailInputField');
    const submitButton = $this.find('.emailInputSubmit');

    $this.find('.emailSignupText').replaceWith(`
      <div class="emailSignupTextContainer">       
        <h3>Newsletter Sign Up</h3>
        <p>Don’t be left behind! Get the latest Blue Cross Arena updates right to your inbox! </p>     
      </div>`);

    $(inputField.add(submitButton)).wrapAll('<div class="signup-form"></div>');

    inputField
      .find('.inputFieldTextbox')
      .val('')
      .attr('placeholder', 'Email Address')
      .attr('aria-label', 'Email address');

    submitButton.find('.emailSubmitButton').text('subscribe');
  });
}

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header').outerHeight();
    const generalMessageHeight = $('.generalmessage').outerHeight();

    if ($('body').hasClass('saffireWindowScrolled')) {
      $('header').css('top', -generalMessageHeight + 'px');
      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight - generalMessageHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight - generalMessageHeight + 50 + 'px');
      }
    } else {
      $('header').css('top', '0');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + 50 + 'px');
      }
    }
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      updateContentMargin();
      clearInterval(interval);
    }
  }, 500);

  $(window).on('scroll', function () {
    updateContentMargin();
  });
  $(window).on('resize', function () {
    updateContentMargin();
  });
}

function makeAccessibleButton($el, label) {
  $el
    .attr({
      tabindex: 0,
      role: 'button',
      'aria-label': label,
    })
    .on('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
}

function removeFocusCart() {
  const cartLink = $('.header .cartMenuLink');
  const href = (cartLink.attr('href') || '').trim();
  const isNavigable = href.startsWith('http');

  if (!isNavigable) {
    cartLink.attr('tabindex', '-1');
  }
}

function createCustomToggle() {
  const $toggle = $('.header .mobile-nav-toggle');

  if (!$toggle.length) return;

  // Avoid duplicating lines
  if (!$toggle.find('.toggle-line').length) {
    let i = 3;
    while (i--) {
      $toggle.append('<span class="toggle-line"></span>');
    }
  }

  // Accessibility: apply only once
  if (!$toggle.data('accessible')) {
    makeAccessibleButton($toggle, 'open menu');
    $toggle.data('accessible', true);
  }
}

function adjustNav() {
  const menuItems = $('.group, .mainNavigationItem');
  const header = $('.header');
  if (menuItems.length > 3) {
    header.addClass('adjustNav-column');
    $('.searchBox').prependTo('.right-module');
  }
}
